import React from 'react'
import styles from './index.module.scss'
import imgDoctor from '../../../images/doctor.png'

interface InvitorInfoProps {
    name: string; // 邀请人名称
    avatUrl: string; // 头像
    hospitalName: string; // 医院名称
}
const InvitorInfo = (props: InvitorInfoProps) => {
    return (
        <div className={styles.invitor_info}>
            <div className={styles.invit_info_header}>
                {/* <div className={styles.header_left}>
                    <div className={`${styles.dot} ${styles.dot_small}`}></div>
                    <div className={`${styles.dot} ${styles.dot_big}`}></div>
                </div>
                <div className={styles.header_center}>邀请人信息</div>
                <div className={styles.header_right}>
                    <div className={`${styles.dot} ${styles.dot_big}`}></div>
                    <div className={`${styles.dot} ${styles.dot_small}`}></div>
                </div> */}
            </div>
            <div className={styles.invit_info_body}>
                <div className={styles.body_wrap}>
                    <div className={styles.invitor_info_avat}>
                        {/* <img src={props.avatUrl} alt="" /> */}
                        <img src={imgDoctor} alt="" />
                    </div>
                    <div className={styles.invitor_info_content}>
                        <div className={styles.invitor_info_name}>{props.name}</div>
                        <div className={styles.invitor_info_hospital}>{props.hospitalName}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvitorInfo